module.exports = __webpack_public_path__ + "assets/img/home_2.af04f675.jpg";